import {
  resetAfterSubmit,
  toggleClosePositionConfirmationModal,
  updateOrderSubmitStatus,
} from 'actions/placeorder';
import { placeOrder } from 'actions/trade';
import { postMessageToMobileApp } from 'components/app/helpers';
import { addLogsToSentry } from 'helpers/sentry';
import { generateOrderSelector, isFormValidSelector } from 'selectors/placeOrderSelector';
import { markPriceState } from 'selectors/priceSelectors';
import { selectedProductState } from 'selectors/tradeSelectors';

export const sumbitOrder = () => (dispatch, getState) => {
  const state = getState();
  const order = generateOrderSelector(state);
  const isFormValid = isFormValidSelector(state);
  const markPrice = markPriceState();
  const selectedProduct = selectedProductState(state);
  dispatch(updateOrderSubmitStatus('loading'));

  const mixpanelData = {
    source: 'Charts',
    quantity: order?.size,
    price: markPrice,
    notional: Number(order?.size) * Number(selectedProduct?.contract_value),
  };

  if (!isFormValid) {
    return;
  }

  dispatch(placeOrder(order, mixpanelData))
    .then(() => {
      postMessageToMobileApp('APPSFLYER_ORDER', {
        user_id: state?.user?.id,
      });
      dispatch(updateOrderSubmitStatus('success'));
      dispatch(resetAfterSubmit());
    })
    .catch(err => {
      dispatch(updateOrderSubmitStatus('error'));
      addLogsToSentry(state?.user, err);
      if (err.response.body.error === 'ClosePositionInsufficientMargin') {
        dispatch(toggleClosePositionConfirmationModal(true));
      }
    });
};

export default sumbitOrder;
